import React, { useEffect, useState } from 'react';
import { SimpleTableHead, SimpleTableRow, Checkbox } from 'cdk-radial';
import { StickySimpleTableHeader } from '../../common/StyledComponents';

export default function PartsDetailsTableHeaders(props: any): JSX.Element {

  const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if(props.selectedRows.length > 0 ){
            const allSelected = props.selectedRows.every((row :any) => row.isSelected);
            setSelectAll(allSelected);
             // Optional: Handle cases where some but not all are selected, e.g., indeterminate state
        }
  }, [props.selectedRows]);

  // Toggle selection of all rows
  const handleSelectAll = () => {
    // Update selectAll state
    setSelectAll(!selectAll);

    if (selectAll) {
      // Update selectedRows based on the new selectAll state
      props.setSelectedRows((prevRows: any) =>
        prevRows.map((row: any) => ({
          ...row,
          isSelected: false
        }))
      );
    }
    else {
      props.setSelectedRows((prevRows: any) =>
        prevRows.map((row: any) => ({
          ...row,
          isSelected: true
        }))
      );
    }
  };

  return (
    <SimpleTableHead>
      <SimpleTableRow>
        <StickySimpleTableHeader colSpan="0" textAlign="left" >
          <Checkbox
            checked={selectAll}
            name={'select-all'}
            onChange={() => {
              handleSelectAll();
            }}            
            dataTestId={`checkbox-${'select'}`}
          />
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          PO #
        </StickySimpleTableHeader>
        <StickySimpleTableHeader
          colSpan="1"
          textAlign="left"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',

          }}
        >
          DMS Customer No.
        </StickySimpleTableHeader>
        <StickySimpleTableHeader
          colSpan="1"
          textAlign="left"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',

          }}
        >
          Part Number
        </StickySimpleTableHeader>

        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          Description
        </StickySimpleTableHeader>

        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          Quantity
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          Price
        </StickySimpleTableHeader>
        {/* <StickySimpleTableHeader
          colSpan="1"
          textAlign="left"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
           
          }}
        >
          DTNA Customer Name
        </StickySimpleTableHeader> */}
        <StickySimpleTableHeader
          colSpan="2"
          textAlign="left"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'

          }}
        >
          Serial Number
        </StickySimpleTableHeader>
        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          VIN
        </StickySimpleTableHeader>

        <StickySimpleTableHeader colSpan="1" textAlign="left" >
          PDC
        </StickySimpleTableHeader>
        <StickySimpleTableHeader
          colSpan="2"
          textAlign="left"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}

        >
          VDI Flag
        </StickySimpleTableHeader>

        <StickySimpleTableHeader
          textAlign="right"
          colSpan="0"
        ></StickySimpleTableHeader>
      </SimpleTableRow>
    </SimpleTableHead>
  );
}
